import { Injectable, signal } from '@angular/core';
import { loadSavedState, saveState } from './saved-state';

const STATE_KEY = 'deezer.loginPrompt';

/** Deezer's login page refuses to be embedded in other sites, so it opens in its own window. */
export const DEEZER_LOGIN_URL = 'https://www.deezer.com/login';

/**
 * After signing in to the app, offers to log in to Deezer too, so the embedded player can play full songs.
 * We cannot tell from here whether the user is logged in to Deezer, so the prompt can be dismissed for good.
 */
@Injectable({ providedIn: 'root' })
export class DeezerLoginPromptService {
  readonly visible = signal(false);

  /** Called after a successful sign-in to the app. */
  requestAfterSignIn(): void {
    if (!loadSavedState(STATE_KEY, { dismissed: false }).dismissed) this.visible.set(true);
  }

  openDeezerLogin(): void {
    window.open(DEEZER_LOGIN_URL, 'deezer-login', 'popup,width=480,height=760');
    this.visible.set(false);
  }

  notNow(): void {
    this.visible.set(false);
  }

  dontAskAgain(): void {
    saveState(STATE_KEY, { dismissed: true });
    this.visible.set(false);
  }
}
